import { render, staticRenderFns } from "./UpgradeHeader.vue?vue&type=template&id=f357ee1a&scoped=true"
import script from "./UpgradeHeader.vue?vue&type=script&lang=js"
export * from "./UpgradeHeader.vue?vue&type=script&lang=js"
import style0 from "./UpgradeHeader.vue?vue&type=style&index=0&id=f357ee1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f357ee1a",
  null
  
)

export default component.exports